import { combineReducers } from 'redux'
import addEditBookDrawerReducers from './reducers/addEditBookDrawer'

export default combineReducers({
  addEditBookDrawer: addEditBookDrawerReducers,
})
